import React from 'react';
import PropTypes from 'prop-types';
import { Box, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(2),
  },
  title: {
    fontSize: theme.typography.subtitle1.fontSize,
    color: theme.palette.common.gray600,
    textTransform: 'uppercase',
    fontWeight: 600,
  },
}));

const AnalyticCard = props => {
  const { title, children, ActionComponent, paperProps } = props;
  const classes = useStyles();
  return (
    <Paper className={classes.paper} {...paperProps}>
      <Box display="flex" flexDirection="column">
        <Box display="flex" my={0.5} alignItems="center">
          {title &&
            <Typography className={classes.title}>{title}</Typography>
          }
          {ActionComponent && <><Box flexGrow={1} /><ActionComponent /></>}
        </Box>
        {children}
      </Box>
    </Paper>
  );
};

AnalyticCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.any,
  ActionComponent: PropTypes.func,
  paperProps: PropTypes.object,
};


export { AnalyticCard };